import { Artwork } from '../artwork/Artwork';
import LocalStorage from '@/utils/LocalStorage';
import { STORE_CART_ITEMS } from '@/AppKeys';
import { GiftCard } from '../gift-card/GiftCard';
import { useGTag } from '../google/google-tag-manager'

export class CartService {

  // ***********************
  // Artworks cart related
  // ***********************
  items: Artwork[] = [];
  country = {};
  isBusiness: boolean = false;
  discount_coupon_code?: string;
  gift_card_code?: string;
  delivery_code?: string;


  // ************************
  // Gift card related items
  // ************************
  giftCards: GiftCard[] = [];
  printGiftCard: boolean = false;
  giftCardTotal: number = 0;


  constructor() {
    this.items = LocalStorage.cartItems;
  }

  get total(){
    return this.items.reduce((prev, next)=>{
      return prev + parseFloat((next.price || '').replace(',', '.')) || 0
    }, 0)
  }

  addItem(artwork: Artwork) {
    if (artwork.id !== undefined && !this.isAlreadyAdded(artwork.id)) {

      const itemToAdd = { ...artwork };
      // add only primary image to cart
      if (artwork.media instanceof Array && artwork.media.length) {
        itemToAdd.media = artwork.media[0];
      }
      // @ts-ignore
      this.items.push(itemToAdd);
      useGTag().addToCart(artwork)
      LocalStorage.set(STORE_CART_ITEMS, this.items);
    } else {
      console.info("Item already in cart");
    }

  }
  removeItem(id: string) {
    console.log("Remove item from cart", id);
    const pos = this.items.findIndex(i => i.id === id);
    const artwork = this.items[pos];
    this.items.splice(pos, 1);
    if(artwork){
      useGTag().removeFromCart(artwork)
    }
    LocalStorage.set(STORE_CART_ITEMS, this.items);
  }
  isAlreadyAdded(id: string): boolean {
    return this.items.findIndex(i => i.id === id) !== -1;
  }
  // During cart details the artwork details might have changed update the localstorage
  updateCartArtworks(artworks: Artwork[]) {
    console.log("updateCartArtworks", artworks);
    LocalStorage.set(STORE_CART_ITEMS, artworks);
    this.items = artworks;
  }



  // ************************
  // Gift card related items
  // ************************
  addGiftCard(item: GiftCard) {
    this.giftCards.push(item);
    this.calculateGiftCardTotal();
  }
  removeGiftCard(index: number) {
    this.giftCards.splice(index, 1);
    this.calculateGiftCardTotal();
    this.printGiftCard = false;
  }
  calculateGiftCardTotal() {
    this.giftCardTotal = this.giftCards.reduce((a, b) => {
      return a + Number(b.amount);
    }, 0);
  }

}
